(function () {
  function initGalleryArrows() {
    var wrapper = document.querySelector('.product__media-wrapper');
    if (!wrapper) return;
    if (wrapper.querySelector('.ms-gallery-arrow')) return;

    var slides = wrapper.querySelectorAll('.product__media-item');
    if (!slides || slides.length <= 1) return;

    var total = slides.length;
    var current = 0;

    var prevBtn = document.createElement('button');
    prevBtn.className = 'ms-gallery-arrow ms-gallery-arrow--prev';
    prevBtn.setAttribute('aria-label', 'F\u00f6reg\u00e5ende bild');
    prevBtn.setAttribute('type', 'button');
    prevBtn.innerHTML = '<svg viewBox="0 0 16 16" fill="none"><path d="M10 3L5 8L10 13" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';

    var nextBtn = document.createElement('button');
    nextBtn.className = 'ms-gallery-arrow ms-gallery-arrow--next';
    nextBtn.setAttribute('aria-label', 'N\u00e4sta bild');
    nextBtn.setAttribute('type', 'button');
    nextBtn.innerHTML = '<svg viewBox="0 0 16 16" fill="none"><path d="M6 3L11 8L6 13" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';

    wrapper.appendChild(prevBtn);
    wrapper.appendChild(nextBtn);

    function updateArrows() {
      prevBtn.classList.toggle('ms-gallery-arrow--disabled', current === 0);
      nextBtn.classList.toggle('ms-gallery-arrow--disabled', current === total - 1);
    }

    function goToSlide(index) {
      if (index < 0 || index >= total) return;
      current = index;

      // Hitta thumbnail-knappen och klicka p\u00e5 den direkt
      // Vi anv\u00e4nder .thumbnail som \u00e4r sj\u00e4lva knapp-elementet i thumbnail-listan
      var thumbnails = wrapper.querySelectorAll('.thumbnail-list__item .thumbnail');
      if (thumbnails && thumbnails[current]) {
        // Simulera ett musklick p\u00e5 sj\u00e4lva thumbnail-knappen (inte modal-opener)
        thumbnails[current].dispatchEvent(new MouseEvent('click', {
          bubbles: false,  // bubbles: false f\u00f6rhindrar propagation till modal-opener
          cancelable: true
        }));
      } else {
        // Fallback: scrolla medialist
        var list = wrapper.querySelector('.product__media-list');
        if (list) {
          var target = slides[current];
          if (target) {
            list.scrollTo({ left: target.offsetLeft, behavior: 'smooth' });
          }
        }
      }

      updateArrows();
    }

    prevBtn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      goToSlide(current - 1);
    });

    nextBtn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      goToSlide(current + 1);
    });

    // Synka current-index n\u00e4r thumbnail klickas manuellt
    var thumbnails = wrapper.querySelectorAll('.thumbnail-list__item .thumbnail');
    thumbnails.forEach(function (btn, i) {
      btn.addEventListener('click', function () {
        current = i;
        updateArrows();
      });
    });

    // Synka via MutationObserver n\u00e4r Dawn s\u00e4tter is-active
    new MutationObserver(function () {
      slides.forEach(function (slide, i) {
        if (slide.classList.contains('is-active')) current = i;
      });
      updateArrows();
    }).observe(wrapper, { subtree: true, attributes: true, attributeFilter: ['class'] });

    updateArrows();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initGalleryArrows);
  } else {
    initGalleryArrows();
    setTimeout(initGalleryArrows, 500);
    setTimeout(initGalleryArrows, 1500);
  }
})();
